export const unconnectedTenantsData = [
  {
    building_name: "Landmark Office Space",
    address: "Canary Wharf",
    percentage: 56,
    tenants: [
      {
        name: "Name name",
        email: "name@company.com",
        sqft: 2420,
        sqm: 2420,
        unrealized_revenue: 123000,
      },
      {
        name: "Name name",
        email: "name@company.com",
        sqft: 840,
        sqm: 840,
        unrealized_revenue: 23000,
      },
      {
        name: "Name name",
        email: "name@company.com",
        sqft: 840,
        sqm: 840,
        unrealized_revenue: 23000,
      },
      {
        name: "Name name",
        email: "name@company.com",
        sqft: 840,
        sqm: 840,
        unrealized_revenue: 23000,
      },
    ],
  },
  {
    building_name: "Building name",
    address: "address comes here",
    percentage: 33,
    tenants: [
      {
        name: "Name name",
        email: "name@company.com",
        sqft: 2420,
        sqm: 2420,
        unrealized_revenue: 123000,
      },
      {
        name: "Name name",
        email: "name@company.com",
        sqft: 2420,
        sqm: 2420,
        unrealized_revenue: 123000,
      },
    ],
  },
  {
    building_name: "Building name",
    address: "address comes here",
    percentage: 25,
    tenants: [
      {
        name: "Name name",
        email: "name@company.com",
        sqft: 2420,
        sqm: 2420,
        unrealized_revenue: 123000,
      },
      {
        name: "Name name",
        email: "name@company.com",
        sqft: 840,
        sqm: 840,
        unrealized_revenue: 23000,
      },
      {
        name: "Name name",
        email: "name@company.com",
        sqft: 840,
        sqm: 840,
        unrealized_revenue: 23000,
      },
      {
        name: "Name name",
        email: "name@company.com",
        sqft: 840,
        sqm: 840,
        unrealized_revenue: 23000,
      },
    ],
  },
];
